export const hamburgerElement = document.querySelector('.header-menu-hamburger') as HTMLElement;
export const megamenuCloseElement = document.querySelector('.megamenu-close') as HTMLElement;

export const hamburgerIconElement = document.querySelector(
  '.header-menu-hamburger__icon'
) as HTMLElement;

export const megamenuWrapperElement = document.querySelector('.megamenu-wrapper') as HTMLElement;

export const megamenuBackdropElements = document.querySelectorAll('.megamenu-backdrop');

export const headerSearchElement = document.querySelector(
  '.header-search__magnifier'
) as HTMLElement;

export const megamenuSearchInputElement = document.getElementById('searchInput') as HTMLElement;
